import { CmsArticleStatusesEnum } from '~/src/models/enums/cms.enum';
import { fallBackOrder } from '~/src/repositories/cms/constants/cms.constants';
import type { DictionaryInterface } from '~/src/repositories/cms/types/cms.sections.types';
import type {
    CmsUpperBlockAttributeInterface,
    UpperBlockInterface,
} from '~/src/repositories/cms/entities/main/types/cms.upper-block.types';

export const getMappedUpperBlockData = (
    data: DictionaryInterface<CmsUpperBlockAttributeInterface>[] | [],
): UpperBlockInterface[] => {
    return (data?.[0]?.articles || [])
        .reduce<UpperBlockInterface[]>((faqItem, elem) => {
            if (elem?.status === CmsArticleStatusesEnum.PUBLISHED) {
                const faqList = elem.attributeCategories.verkhniy_blok?.attributes;
                faqItem.push({
                    id: elem.id,
                    image: faqList?.image?.value || null,
                    text: faqList?.text?.value || null,
                    order: elem?.order || fallBackOrder,
                });
            }
            return faqItem;
        }, [])
        .sort((item, elem) => (item?.order || fallBackOrder) - (elem?.order || fallBackOrder));
};
